import { AiOutlineFieldTime } from "react-icons/ai";
import { BsTags } from "react-icons/bs";
import { FiUsers } from "react-icons/fi";
import { RxDashboard, RxStopwatch, RxIdCard } from "react-icons/rx";
import { TbBrandUnity } from "react-icons/tb";

export const navLinks = (isScaled: any, _activeType?: string) => {
  return (
    [
      {
        to: "/dashboard",
        icon: <RxDashboard size={isScaled ? 18 : 20} />,
        text: "Dashboard",
      },
      {
        to: "/3d-dashboard",
        icon: <TbBrandUnity size={isScaled ? 18 : 20} />,
        text: "3D Visualization",
      },
      {
        to: "/dashboard-configuration",
        icon: <BsTags size={isScaled ? 18 : 20} />,
        text: "Tags",
      },
      {
        to: "/alarms",
        icon: <RxStopwatch size={isScaled ? 18 : 20} />,
        text: "Alarms",
      },
      {
        to: "/tickets",
        icon: <RxIdCard size={isScaled ? 18 : 20} />,
        text: "Tickets",
      },
      {
        to: "/users",
        icon: <FiUsers size={isScaled ? 18 : 20} />,
        text: "Users",
      },
      {
        to: "/logs",
        icon: <AiOutlineFieldTime size={isScaled ? 18 : 20} />,
        text: "Logs",
      },
      // {
      //   to: "/dxf-data-mapping",
      //   icon: <TbFileSpreadsheet size={isScaled ? 18 : 20} />,
      //   text: "DXF with Data",
      // },
      // {
      //   to: `${process.env.REACT_APP_COMMON_APP}`,
      //   icon: <RxGlobe size={isScaled ? 18 : 20} />,
      //   text: "Back to Saudi Map",
      // },
    ]

  );
};